import { NodeEventPlugin } from '@lexical/react/LexicalNodeEventPlugin'
import { TableCellNode } from '@lexical/table'

import { useContextMenuStore } from '@eastcoal/common/components/ContextMenu/Store/hooks/useStore'

import { useEditor } from '../../hooks/useEditor'
import { TableContextMenu } from '../../ui/TableContextMenu'
import { $resetTableSelectionOutofEventTarget } from '../../utils/table'

import {
  TABLE_COLUMN_COUNT_CHANGE_COMMAND,
  TABLE_ROW_COUNT_CHANGE_COMMAND
} from './commands'

const PluginCore = () => {
  const editor = useEditor()
  const openContextMenu = useContextMenuStore(state => state.open)

  return (
    <NodeEventPlugin
      eventType='contextmenu'
      nodeType={TableCellNode}
      eventListener={(e, __, nodeKey) => {
        const event = e as PointerEvent
        const target = event.target as HTMLElement
        event.preventDefault()
        event.stopPropagation()
        $resetTableSelectionOutofEventTarget(editor, target)
        openContextMenu(
          {
            x: event.pageX,
            y: event.pageY
          },
          { tableKey: nodeKey }
        )
      }}
    />
  )
}

export const TableContextMenuPlugin = () => {
  const editor = useEditor()

  const handleRowCountChange = () => {
    editor.dispatchCommand(TABLE_ROW_COUNT_CHANGE_COMMAND, undefined)
  }

  const handleColumnCountChange = () => {
    editor.dispatchCommand(TABLE_COLUMN_COUNT_CHANGE_COMMAND, undefined)
  }

  return (
    <TableContextMenu
      onDeleteColumn={handleColumnCountChange}
      onDeleteRow={handleRowCountChange}
      onInsertColumn={handleColumnCountChange}
      onInsertRow={handleRowCountChange}
    >
      <PluginCore />
    </TableContextMenu>
  )
}
